import { render, staticRenderFns } from "./BuffetStatis.vue?vue&type=template&id=6ead2d20&scoped=true&"
import script from "./BuffetStatis.vue?vue&type=script&lang=js&"
export * from "./BuffetStatis.vue?vue&type=script&lang=js&"
import style0 from "./BuffetStatis.vue?vue&type=style&index=0&id=6ead2d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ead2d20",
  null
  
)

export default component.exports